import { render, staticRenderFns } from "./SpecificFrequency.vue?vue&type=template&id=99fe78da&scoped=true"
import script from "./SpecificFrequency.vue?vue&type=script&lang=js"
export * from "./SpecificFrequency.vue?vue&type=script&lang=js"
import style0 from "./SpecificFrequency.vue?vue&type=style&index=0&id=99fe78da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fe78da",
  null
  
)

export default component.exports